// 所有 sports map 数据中心
import SPORTS_LIST from 'public/lib/sports.json'
import { getStorage } from '@ms/utils/storage'

const KEY_SPORTS_MAP = 'SPORTS_MAP'

// 是否是电竞运动
export const checkEsport = (sportId = '') => SPORTS_LIST.esportIds.includes(sportId)

/**
 * A constant that holds the cached sports map.
 *
 * @constant {Object} ALL_SPORTS_MAP { [sportId]: sportName }
 * @default {}
 */
export const ALL_SPORTS_MAP = getStorage(KEY_SPORTS_MAP, {})

export const batchUpdateSportsMap = (sports = []) => {
  let changed = false
  sports.forEach(({ sportId, sportName }) => {
    if (!ALL_SPORTS_MAP[sportId] || ALL_SPORTS_MAP[sportId] !== sportName) {
      ALL_SPORTS_MAP[sportId] = sportName
      changed = true
    }
  })

  if (changed) {
    localStorage.setItem(KEY_SPORTS_MAP, JSON.stringify(ALL_SPORTS_MAP))
  }
}

batchUpdateSportsMap(SPORTS_LIST.sports)

const getLOLInfo = (sportName = '') => {
  if (/^League of Legends|LOL/i.test(sportName)) {
    const sportId = 'sr:sport:110'
    return { sportId, sportName: ALL_SPORTS_MAP[sportId], title: 'LOL' }
  }
}

const getCSGO = (sportName = '') => {
  if (/^CS:GO|CSGO|CS GO|Counter-Strike/i.test(sportName)) {
    const sportId = 'sr:sport:109'
    return { sportId, sportName: ALL_SPORTS_MAP[sportId], title: 'CS GO' }
  }
}

const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Parses the sport information based on the given sport name.
 *
 * @param {string} [sportName=''] - The name of the sport to parse.
 * @returns {Object|null} The parsed sport information, or null if not found.
 * @returns {string} return.sportId - The ID of the sport.
 * @returns {string} return.sportName - The name of the sport.
 */
export const parseSportByName = (sportName = '') => {
  if (!sportName) return
  if (sportName.indexOf('%') !== -1) {
    sportName = decodeURIComponent(sportName)
  }

  const lolInfo = getLOLInfo(sportName)
  if (lolInfo) return lolInfo

  const csgoInfo = getCSGO(sportName)
  if (csgoInfo) return csgoInfo

  const reg = new RegExp(`^${escapeRegExp(sportName)}`, 'i')
  const info = Object.entries(ALL_SPORTS_MAP).find(([, mSportName]) => reg.test(mSportName))
  if (info) {
    return { sportId: info[0], sportName: info[1] }
  }
  return null
}

/**
 * Checks if the given sport ID is valid.
 *
 * @param {string} [sportId=''] - The sport ID to validate.
 * @returns {boolean} - Returns true if the sport ID is valid, otherwise false.
 */
export const isValidSportId = (sportId = '') => !!ALL_SPORTS_MAP[sportId]

export const getSportName = (sportId = '') => ALL_SPORTS_MAP[sportId] || ''
